import { render, staticRenderFns } from "./RegiaoTabela.vue?vue&type=template&id=322b8d14&lang=html&"
import script from "./RegiaoTabela.vue?vue&type=script&lang=js&"
export * from "./RegiaoTabela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/regiao/RegiaoTabela.vue
// module id = 1456
// module chunks = 28